/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Livid_Fly_SingInputs */

const fr_zesty_livid_fly_sing = /** @type {(inputs: Zesty_Livid_Fly_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer PB`)
};

/**

* @param {Zesty_Livid_Fly_SingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zesty_livid_fly_sing = /** @type {((inputs?: Zesty_Livid_Fly_SingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Livid_Fly_SingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zesty_livid_fly_sing(inputs)
});